<template>
  <div class="caseStatistics">
    <div class="top wbg" v-if="$common.AUTH('statis:referee:lists')">
      <a-row class="row" :gutter="20">
        <a-col class="flex" :span="5">
          <label>委托类型：</label>
          <a-select placeholder="请选择委托类型" class="select">
            <a-select-option :value="1">委托代理</a-select-option>
            <a-select-option :value="2">委托管理</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>原告：</label>
          <a-select v-model="form.accuser_id" placeholder="请选择原告" class="select" mode="multiple" :maxTagCount='1'
            :maxTagTextLength='6' allowClear :filter-option="$common.filterOption">
            <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id" :title="item.title">{{
              item.title
              }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="6" class="flex">
          <label>管辖法院：</label>
          <a-select v-model="form.court_id" placeholder="请选择管辖法院" class="select" mode="multiple" :maxTagCount='1'
            :maxTagTextLength='6' @search="handleSearch" :default-active-first-option="false" :show-arrow="false"
            :filter-option="false" :not-found-content="null" allowClear>
            <a-select-option v-for="item in courtList" :key="item.title" :value="item.id" :title="item.title">{{
              item.title
              }}</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="7" class="flex">
          <label>签收日期：</label>
          <timePick @PickTime="PickTime" ref="timePicker"></timePick>
        </a-col>
      </a-row>
      <a-row class="row" :gutter="20" style="margin-bottom:0;">
        <a-col :span="5" class="flex">
          <label>案件类型：</label>
          <a-select class="select" v-model='form.cause_type' placeholder="请选择案件类型" allowClear>
            <a-select-option :value="1">诉讼</a-select-option>
            <a-select-option :value="2">仲裁</a-select-option>
            <a-select-option :value="3" disabled>公证</a-select-option>
            <a-select-option :value="4" disabled>调解</a-select-option>
          </a-select>
        </a-col>
        <a-col :span="8" class="flex">
          <a-button icon="search" style="height:32px;" @click='page.page = 1; query()'>查询</a-button>
          <a-button style="height:32px;margin-left: 20px;" @click='reset'>重置</a-button>
          <a-button icon="upload" style="height:32px;margin-left:20px;" @click="out(4)"
            v-if='$common.AUTH("export:cpwsb")'>导出</a-button>
        </a-col>
      </a-row>
    </div>
    <div class="conmains" v-if="$common.AUTH('statis:referee:lists')">
      <div class="h2">文书统计</div>
      <div class="mains">
        <div class="con">
          <!-- <div class="li"><div class="tit">待还款总额(元)</div><div class="p">{{ static.sum  | showYuan}}</div></div> -->
          <div class="li">
            <div class="tit">裁判文书总数量</div>
            <div class="p">{{ rNum(0) }}</div>
          </div>
          <div class="li">
            <div class="tit">判决书</div>
            <div class="p">{{ rNum(1) }}</div>
          </div>
          <div class="li">
            <div class="tit">调解书</div>
            <div class="p">{{ rNum(2) }}</div>
          </div>
          <div class="li">
            <div class="tit">撤诉裁定</div>
            <div class="p">{{ rNum(5) }}</div>
          </div>
          <div class="li">
            <div class="tit">其他裁定</div>
            <div class="p">{{ rNum(3) }}</div>
          </div>
        </div>
        <div class="rt chartDiy">
          <lineChart type="2" id="linechart" :datas="lineData" v-if="lineData.load"></lineChart>
        </div>
      </div>

      <div class="h3">文书信息</div>
      <div class="tcon">
        <div class="tableList">
          <div class="table">
            <table>
              <thead>
                <td style="width: 70px;">序号</td>
                <td style="width: 70px;">被告</td>
                <td style="width: 160px;">证件号码/代码</td>
                <td style="width: 65px;">所属案件</td>
                <td width="210">原告</td>
                <td width="220">管辖法院</td>
                <td width="120">判决进度</td>
                <td width="80">文书类型</td>
                <td width="140">文书签收时间</td>
              </thead>
              <tbody>
                <tr v-for='(i, index) in newO.list' :key='index'>
                  <td>{{ index + 1 + (10 * (page.page - 1)) }}</td>
                  <td>
                    <span class="curpoter" @click='dbclick(i)'>
                      <Normap :tit='i.realname'>{{ i.realname }}</Normap>
                    </span>
                  </td>
                  <td>{{ i.chinaid }}</td>
                  <td>
                    <p v-for='(j, index) in i.cause' :key="index">
                      案件{{ j.sort }}
                    </p>
                  </td>
                  <td>
                    <p v-for="(j, index) in i.cause" :key="index">
                      <Normap :tit='j.accuser ? j.accuser.title : "/"'></Normap>
                    </p>
                  </td>
                  <td>
                    <p v-for="(j, index) in i.cause" :key="index">
                      <Normap :tit='j.court'>{</Normap>
                    </p>
                  </td>
                  <td>
                    <p v-for="(j, index) in i.cause" :key="index">
                      {{ j.step_cpws.length ? j.step_cpws[0].title : '/' }}
                    </p>
                  </td>
                  <td>
                    <p v-for="(j, index) in i.cause" :key="index">
                      {{ j.step_cpws.length ? j.step_cpws[0].type_title : '/' }}
                    </p>
                  </td>
                  <td>
                    <p v-for="(j, index) in i.cause" :key="index">
                      {{ j.step_cpws.length ? (j.step_cpws[0].receive_time || '/') : '/' }}
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="pages">
            <a-pagination v-model="page.page" show-quick-jumper :total="newO.debtor_count" show-less-items
              :pageSize='10' @change='turnpage'
              :show-total="(total) => `被告：${newO.debtor_count} 案件数：${newO.cause_count}`" />

          </div>
        </div>

      </div>
    </div>
    <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
  </div>
</template>

<script>
import { getAccuserAll } from '@/server/api'
import { getDirectory } from "@/server/directory"
import { cpwsStatis, cpwsList, analyseBook } from '@/server/collection'
import lineChart from '@/components/charts'
import { exportForm } from '@/assets/js/unit'
export default {
  components: { lineChart },
  data() {
    return {
      cpwsData: [],
      newO: {
        cause_count: 0,
        debtor_count: 0,
        list: [],
      },
      lineData: { load: false },
      page: {
        page: 1,
        limit: 10,
      },
      courtList: [],
      accuserList: [],
      form: {
        cause_type: undefined,
        accuser_id: [],
        court_id: [],
        receive_date_start: '',
        receive_date_end: ''
      },
    }
  },
  created() {
    this.query()
    getAccuserAll().then((res) => {
      this.accuserList = res.list
    })
    this.handleSearch('')
  },
  methods: {
    out(type) {
      if (this.form.receive_date_start && this.form.receive_date_end) {
        const form = JSON.parse(JSON.stringify(this.form));
        exportForm(type, form)
      } else {
        this.$message.error('请先选择时间再执行导出');
      }
    },
    rNum(type) {
      if (this.cpwsData.length) {
        let all = this.cpwsData.find(ele => { return ele.type === type });
        if (all) return all.count
        else return 0
      } else
        return 0
    },
    handleSearch(val) {
      getDirectory({
        limit: 100,
        title: val
      }).then((res) => {
        this.courtList = res.list
      })
    },
    turnpage(val) {
      this.page.page = val
      this.getList()
    },

    PickTime(e) {
      if ("stime" in e) {
        this.form.receive_date_start = e.stime
      } else {
        this.form.receive_date_end = e.etime
      }
    },
    query() {
      const form = JSON.parse(JSON.stringify(this.form))
      form.accuser_id = form.accuser_id.toString()
      form.court_id = form.court_id.toString()
      this.$set(this.lineData, 'load', false)
      cpwsStatis(form).then(e => {
        this.cpwsData = e;
        const num0 = this.rNum(2), num1 = this.rNum(1), num2 = e.filter(s => { return s.type == 3 || s.type == 5 }).reduce((prev, next) => { return prev + next.count }, 0);
        const all = this.rNum(0);
        // console.log(num0, num1, num2)
        this.lineData = {
          load: true,
          label: ['调解书', '判决书', '其他'],
          list: [num0, num1, num2],
          arr: [num0 / all, num1 / all, num2 / all]
        }
      })
      this.getList()
    },
    reset() {
      this.form.limit = 10
      this.form.page = 1
      this.form.cause_type = undefined
      this.form.accuser_id = []
      this.form.court_id = []
      this.form.receive_date_start = ''
      this.form.receive_date_end = ''
      this.$refs.timePicker.clearTime()
      this.query()
    },
    dbclick(record) {
      if (this.$common.AUTH('debtor:info')) {
        let routeUrl = this.$router.resolve({ "name": "lydetails", params: { "id": record.cause[0].debtor_id } });
        window.open(routeUrl.href, '_blank');
      }
      else {
        this.$message.error({ content: '暂无权限', key: 'updatable' });
      }
    },
    getList() {
      const form = JSON.parse(JSON.stringify(this.form))
      form.page = this.page.page;
      form.limit = this.page.limit;
      form.accuser_id = form.accuser_id.toString()
      form.court_id = form.court_id.toString()
      cpwsList(form).then(e => {
        this.newO = e;
      })
    }
  }
}
</script>
<style lang="less">
.caseStatistics {
  .chartDiy {
    .tipbox {
      width: 160px;
      box-shadow: 0 0 3px #ccc;
      padding: 10px;
      background: #fff;

      .p {
        display: flex;
        align-items: center;

        &::before {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          content: "";
          background: #52c41a;
          margin-right: 4px;
        }
      }

      .zb {
        &::before {
          background: #40a9ff;
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
.caseStatistics {
  // padding-bottom: 50px;
  @import url('@/assets/css/search.less');
}

.conmains {
  margin-top: 10px;

  .mains {
    display: flex;
    justify-content: space-between;
    background: #F6F8FC;
    margin: 20px 20px 0;
    padding: 20px;
  }

  background: #fff;

  .con {
    height: 150px;
    flex: 3;
    display: flex;

    .li {

      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 15%;
      flex-direction: column;

      &:nth-last-child(1) {
        width: 10%;
      }

      .tit {
        font-size: 0.875rem;
        font-weight: 500;
        color: #0E2949;
        line-height: 20px;
      }

      .p {
        font-size: 0.875rem;
        font-weight: 500;
        margin-top: 5px;
        color: #0E2949;
        line-height: 20px;
      }
    }
  }

  .rt {
    width: 300px;
    height: 150px;
  }
}

.h2,
.h3 {
  line-height: 62px;
  padding-left: 20px;
  font-size: 1rem;
  color: #0e2949;
  font-weight: bold;
  border-bottom: 1px solid #efefef;
}

.h3 {
  padding: 0;
  margin: 0 20px;
}

.tcon {
  padding: 0 20px;
  min-height: 720px;
  margin-top: 20px;

  .tableList {
    width: 100%;

    .table {
      thead {
        td {
          padding-left: 0;

          &:nth-child(1) {
            padding-left: 20px;
          }
        }
      }

      tbody {
        tr:nth-last-child(1) {
          border-bottom: 1px solid #ebebeb;
        }

        td {
          padding: 6px 0;
          height: 60px;

          &:nth-child(1) {
            padding-left: 20px;
          }

          p {
            padding: 10px 10px 10px 0;
            margin: 0;
            border-bottom: 1px solid #ebebeb;

            &:nth-last-child(1) {
              border: 0 none;
            }
          }
        }
      }
    }
  }
}

.pages {
  text-align: right;
  position: relative;
}
</style>
